<script>
    import ConfirmDialog from "./confirm-dialog.vue";
    import API from "../../API";
    import toaster from "../common/toaster";

    export default {
        name: "confirm-delete-dialog",
        components: { ConfirmDialog },
        data() {
            return {
                showDialog: false,
                ids: undefined,
                entityName: undefined,
                name: undefined,
                message: undefined,
                confirmMsg: undefined,
                multiMode: false,
                reloadEventName: undefined,
                mmsids: undefined,
            };
        },
        computed: {
            title() {
                return Lang.langGet('Confirm delete');
            }
        },
        methods: {
            show() {
                this.showDialog = true;
            },
            hide() {
                this.showDialog = false;
            },
            getData() {
                if (this.multiMode) return {id: this.ids};
                else return {id: this.ids[0]};
            },
            async handleConfirm() {
                const api = new API(this.url);

                if (this.type === 'POST') {
                    const data = this.getData();
                    const result = await api.post(data);

                    if (result.errored) {
                        toaster.error(Lang.langGet("Failed to delete element!"));
                    } else {
                        if (this.multiMode && this.name.length > 1) {
                            toaster.success(Lang.langGet("The elements were successfully deleted."));
                        } else {
                            toaster.success(Lang.langGet("The element was successfully deleted."));
                        }
                        if (this.reloadEventName) {
                            EaseEventBus.fire(this.reloadEventName);
                        } else {
                            EaseEventBus.fire(`reload${_.capitalize(this.entityName)}Table`);
                        }
                        if (this.entityName === 'screengroup') {
                            EaseEventBus.fire('pushDeletedScreengroupIds', this.mmsids);
                        }
                        this.hide();
                    }
                }
            }
        },
        mounted() {
            EaseEventBus.listen('confirmDeleteDialog', params => {
                if (!params.ids || !params.url || !params.entityName) {
                    throw new Error('Id, url and entityName are required for deletion!');
                }

                this.ids = params.ids;
                this.url = params.url;
                this.entityName = params.entityName;
                this.reloadEventName = params.reloadEventName;
                if (params.entityName === 'screengroup') {
                    this.mmsids = params.mmsids;
                }

                this.multiMode = params.multiMode;

                this.message = params.message;
                this.confirmMsg = params.confirmMsg;
                if (!this.message) {
                    if (this.multiMode && params.name.length > 1) {
                        this.message = Lang.langGet('Do you really want to delete the selected elements?');
                    } else {
                        this.message = Lang.langGet('Do you really want to delete this element?');
                    }
                }

                this.type = params.type;
                if (!this.type) {
                    this.type = 'POST';
                }

                this.name = params.name;
                this.show();
            })
        }
    }
</script>

<template>
    <confirm-dialog v-if="showDialog" class="border"
        :title="title"
        :message="message"
        :confirmMsg="confirmMsg"
        :showDialog="showDialog"
        @cancel="hide"
        @confirm="handleConfirm"
        noIcons
        showTextIcon
    />
</template>
